// CTSK-525 — first-page PDF thumbnail. pdfjs-dist and its worker are pulled in
// with dynamic imports so they only load on the first PDF expand. The worker
// URL is a same-origin Vite asset (?url), compatible with worker-src 'self'.

let pdfjsPromise: Promise<typeof import('pdfjs-dist')> | null = null;

export function loadPdfJs(): Promise<typeof import('pdfjs-dist')> {
  if (!pdfjsPromise) {
    pdfjsPromise = (async () => {
      const [lib, worker] = await Promise.all([
        import('pdfjs-dist'),
        import('pdfjs-dist/build/pdf.worker.min.mjs?url'),
      ]);
      lib.GlobalWorkerOptions.workerSrc = worker.default;
      return lib;
    })();
    pdfjsPromise.catch(() => { pdfjsPromise = null; });
  }
  return pdfjsPromise;
}

export async function renderPdfFirstPage(url: string, canvas: HTMLCanvasElement, targetWidth: number): Promise<void> {
  const lib = await loadPdfJs();
  const task = lib.getDocument({ url, withCredentials: true });
  try {
    const pdf = await task.promise;
    const page = await pdf.getPage(1);
    const base = page.getViewport({ scale: 1 });
    const scale = Math.max(0.1, targetWidth / base.width);
    const viewport = page.getViewport({ scale });
    canvas.width = Math.floor(viewport.width);
    canvas.height = Math.floor(viewport.height);
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('canvas unavailable');
    await page.render({ canvasContext: ctx, viewport }).promise;
  } finally {
    void task.destroy();
  }
}
